import { render, staticRenderFns } from "./AudienceAssociatedCampaignsGrid.vue?vue&type=template&id=610ce328&"
import script from "./AudienceAssociatedCampaignsGrid.vue?vue&type=script&lang=js&"
export * from "./AudienceAssociatedCampaignsGrid.vue?vue&type=script&lang=js&"
import style0 from "./AudienceAssociatedCampaignsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports